import * as types from 'actions/actionTypes';
import initialState from './initialState';
import * as globalVars from 'settings/globalVars';
import * as settings from 'settings/settings';
import $ from 'jquery';

/**
 * reducer per gestire i dati di base dell'applicativo
 * @param {*} state
 * @param {*} action
 */
export default function appDataReducer(state = initialState.appData, action){

    switch(action.type)
    {
        case types.LOAD_APPDATA:

            var apiKey = globalVars.getCalAmpAppKey();

            /*
                se esiste la cerco nella lista e la salvo in memoria
            */
            var selectedApp;

            $.each(settings.ApplicationKeyList, function (index, item){
                if(item.key === apiKey)
                {
                    selectedApp = item;
                    return;
                }
            });

            const severityCodeListForDropDown = state.severityCodeList.map(item => {
                return {
                    id: item.id,
                    value: item.code,
                    localizationKey: item.localizationKey
                };
            });

            const eventClassificationListForDropDown = state.eventClassificationList.map(item => {
                return {
                    id: item.id,
                    value: item.code,
                    localizationKey: item.localizationKey
                };
            });

        return {...state, severityCodeListForDropDown: severityCodeListForDropDown,
            eventClassificationListForDropDown: eventClassificationListForDropDown,
            selectedApplication: selectedApp };

        case types.APP_SAVEAPPLICATION_SUCCESS:
            console.info("saving app in state");

            return {...state, selectedApplication: action.data};

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/appDataReducer.js